import Axios from "axios"
import React, { Suspense, lazy, useEffect } from 'react';
import { Routes, Route, useLocation, useNavigate } from 'react-router-dom';
// ============================================
// LOGIN FUNCTIONALITY COMMENTED OUT
// ============================================
// import { GoogleOAuthProvider } from '@react-oauth/google';
// import { AuthProvider } from '../context/AuthContext';
import "./styles/global.css"
import config from '../config/environment';
import { toLowerCasePath } from '../extensions/utilityExtensions';
import LoadingPage from "./LoadingPage";
import { AdManager } from './ads';
import { STRAPI_API } from '../constants';

// Environment Variables
const API_URL = config.API_URL;

// URL Normalizer component
function RouteNormalizer() {
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        // Check if the current path contains uppercase letters
        if (location.pathname !== location.pathname.toLowerCase()) {
            // Create the lowercase version of the path
            const lowercasePath = location.pathname.toLowerCase();

            // Navigate to the lowercase path, preserving search params and hash
            navigate(`${lowercasePath}${location.search}${location.hash}`, { replace: true });
        }
    }, [location, navigate]);

    return null;
}

// Lazy loaded components
const Home = lazy(() => import('./pages/home'));
const Forum = lazy(() => import('./pages/forum'));
const Library = lazy(() => import('./pages/library'));
const BlogPage = lazy(() => import('./pages/blogPage'));
const BlogEditor = lazy(() => import('./pages/blogEditor'));
const SearchPage = lazy(() => import('./pages/searchPage'));
const ContactUs = lazy(() => import('./pages/contactUs'));
const About = lazy(() => import('./pages/about'));
const OurTools = lazy(() => import('./pages/ourTools'));
const PrivacyAndCookies = lazy(() => import('./pages/privacyAndCookies'));
const BlogList = lazy(() => import('./pages/blogList'));
const NotFoundPage = lazy(() => import('./NotFoundPage'));

// ============================================
// LOGIN FUNCTIONALITY COMMENTED OUT
// ============================================
// Auth components
// const Login = lazy(() => import('./auth/Login'));
// const UserProfile = lazy(() => import('./auth/UserProfile'));
// const ProtectedRoute = lazy(() => import('./auth/ProtectedRoute'));

class ErrorBoundary extends React.Component {
    state = { hasError: false };

    static getDerivedStateFromError(error) {
        return { hasError: true };
    }

    render() {
        if (this.state.hasError) {
            return (
                <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', background: '#010a2f' }}>
                    <h1 style={{ color: '#fff', marginBottom: '20px' }}>Something went wrong</h1>
                    <p style={{ color: '#ccc', marginBottom: '30px' }}>We're sorry, but there was an error loading this page.</p>
                    <button
                        onClick={() => window.location.reload()}
                        style={{
                            padding: '10px 20px',
                            background: '#00e8ff',
                            border: 'none',
                            borderRadius: '4px',
                            cursor: 'pointer',
                            color: '#000',
                            fontWeight: 'bold'
                        }}
                    >
                        Reload Page
                    </button>
                </div>
            );
        }
        return this.props.children;
    }
}

function App() {
    // Example of fetching blog posts from Strapi
    const [posts, setPosts] = React.useState([]);

    React.useEffect(() => {
        fetch(`${STRAPI_API.ARTICLES}?populate=*`)
            .then(res => {
                const contentType = res.headers.get("content-type");
                if (!res.ok) {
                    // throw new Error('Network response was not ok');
                    return { data: [] };
                }
                if (!contentType || !contentType.includes("application/json")) {
                    return { data: [] };
                }
                return res.json();
            })
            .then(data => setPosts(data))
            .catch(error => {
                console.error('Error fetching articles:', error);
            });
    }, []);

    return (
        // ============================================
        // LOGIN FUNCTIONALITY COMMENTED OUT
        // ============================================
        // <GoogleOAuthProvider clientId={config.GOOGLE_CLIENT_ID || ''}>
        //     <AuthProvider>
        <ErrorBoundary>
            <AdManager />
            <Suspense fallback={<LoadingPage message="Loading page..." />}>
                {/* URL Normalizer to handle case-insensitive routing */}
                <RouteNormalizer />

                <Routes>
                    {/* ============================================ */}
                    {/* LOGIN FUNCTIONALITY COMMENTED OUT */}
                    {/* ============================================ */}
                    {/* Auth Routes */}
                    {/* <Route path="/login" element={<Login />} /> */}
                    {/* <Route path="/profile" element={
                                <React.Suspense fallback={<LoadingPage message="Loading profile..." />}>
                                    <ProtectedRoute>
                                        <UserProfile />
                                    </ProtectedRoute>
                                </React.Suspense>
                            } /> */}

                    {/* Main Routes */}
                    <Route path="/">
                        <Route index element={<Home />} />
                        <Route path={toLowerCasePath("home")} element={<Home />} />
                        <Route path={toLowerCasePath("library")} element={<Library />} />

                        {/* Forum routes - ensure correct parameter naming */}
                        <Route path={toLowerCasePath("forum")} element={<Forum />} />
                        <Route path={toLowerCasePath("forum/:sectionName")} element={<Forum />} />

                        <Route path={toLowerCasePath("blog")}>
                            <Route index element={<BlogList />} />
                            <Route path={toLowerCasePath(":blogName")} element={<BlogPage />} />
                            <Route path={toLowerCasePath("editor")} element={<BlogEditor />} />
                        </Route>
                        <Route path={toLowerCasePath("search/:blogSearchQuery")} element={<SearchPage />} />
                        <Route path={toLowerCasePath("privacy-and-cookies")} element={<PrivacyAndCookies />} />
                        <Route path={toLowerCasePath("contact-us")} element={<ContactUs />} />
                        <Route path={toLowerCasePath("about")} element={<About />} />
                        <Route path={toLowerCasePath("our-tools")} element={<OurTools />} />
                        <Route path={toLowerCasePath("list")} element={<BlogList posts={posts} />} />
                    </Route>

                    {/* 404 catch-all route */}
                    <Route path="*" element={<NotFoundPage />} />
                </Routes>
            </Suspense>
        </ErrorBoundary>
        //     </AuthProvider>
        // </GoogleOAuthProvider>
    );
}

export default App;